import { render, staticRenderFns } from "./DemandList.vue?vue&type=template&id=4cd63d28&scoped=true"
import script from "./DemandList.vue?vue&type=script&lang=ts"
export * from "./DemandList.vue?vue&type=script&lang=ts"
import style0 from "./DemandList.vue?vue&type=style&index=0&id=4cd63d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd63d28",
  null
  
)

export default component.exports